import { createStore } from "vuex";

export default createStore({
  state: {
    companyID: "",
    token: false,
    readings: [],
  },
  getters: {
    getCompanyID(state) {
      return state.companyID;
    },
    getToken(state) {
      return state.token;
    },
    getReadings(state) {
      return state.readings;
    },
    todaysReadings(state) {
      const today = new Date().toDateString();
      return state.readings.filter(
        (r) => new Date(r.timestamp).toDateString() === today
      );
    },
    failedReadingsToday(state) {
      const today = new Date().toDateString();
      return state.readings.filter(
        (r) =>
          new Date(r.timestamp).toDateString() === today && r.pass === false
      );
    },
  },
  mutations: {
    companyIDMutation(state, payload) {
      state.companyID = payload;
    },
    tokenMutation(state, payload) {
      state.token = payload;
    },
    setReadings(state, payload) {
      state.readings = payload;
    },
    prependReading(state, payload) {
      state.readings.unshift(payload);
    },
  },
  actions: {
    companyIDAction({ commit }, payload) {
      commit("companyIDMutation", payload);
    },
    tokenAction({ commit }, payload) {
      commit("tokenMutation", payload);
    },
    setToken({ commit }, payload) {
      commit("tokenMutation", payload);
    },
    setReadings({ commit }, payload) {
      commit("setReadings", payload);
    },
    addReading({ commit }, payload) {
      commit("prependReading", payload);
    },
  },
  modules: {},
});
